export const calculateDays = (expirationDate:any) => {
  const endDate:any = new Date(expirationDate)
  const startDate:any = new Date()

  const diffInMs:any   = endDate - startDate
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return Math.ceil(diffInDays)
}

export enum AlertType {
  WARNING = 'warning',
  EXPIRED = 'danger',
  GRACEPERIOD = 'custom'
}